todays-deliveries-letters-btn
  span.btn-download.btn.btn-success.btn-sm(onClick="{this.onClick}")
    i.feather.icon-download
    | { opts.label }
  script(type="typescript").
    this.mixin('base');
